import { columnHelper } from './helper';

export const title = columnHelper.accessor('title', {
  header: 'Title',
  id: 'title',
});
